import { useRef } from "react";
import { AgGridReact } from "ag-grid-react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";
import { useInitUserSearchFilter } from "src/hooks/useInitUserSearchFilter";
import useUiuxStore from "src/store/useUiuxStore";
import { useMouseContent } from "src/utils/mouse/mouseContent";

import { Content_KSK2130_R01 } from "./Content_KSK2130_R01";
import { DetailTable_KSK2130_R01 } from "./DetailTable_KSK2130_R01";
import {
  KSK2130_R01DetailDto,
  KSK2130_R01HeaderDto,
} from "./Dto_KSK2130_R01";
import { Info_KSK2130_R01 } from "./Info_KSK2130_R01";
import { Modal_KSK2130_R01 } from "./Modal_KSK2130_R01";
import { SearchSection_KSK2130_R01 } from "./SearchSection_KSK2130_R01";
import { useKSK2130_R01Store } from "./Store_KSK2130_R01";
import { Table_KSK2130_R01 } from "./Table_KSK2130_R01";

const TABLE_DETAIL_RESIZER = {
    code: "KSK2130_R01",
    type: "height" as const,
    storageKey: "KSK2130_R01-table-detail-split-height",
    min: 25,
    max: 80,
    default: 55,
};

export const Container_KSK2130_R01 = () => {
    useFetchActionbarAuth("KSK2130_R01");
    const { setMessage } = useUiuxStore();
    const { isMaterialLotModalVisible, KSK2130_R01Filter, setKSK2130_R01Filter } = useKSK2130_R01Store();
    useInitUserSearchFilter(setKSK2130_R01Filter, KSK2130_R01Filter);
    const gridRef = useRef<AgGridReact<KSK2130_R01HeaderDto> | null>(null);
    const detailGridRef = useRef<AgGridReact<KSK2130_R01DetailDto> | null>(null);
    const containerRef = useRef<HTMLDivElement>(null);
    const isResizing = useRef(false);

    const { splitValue, handleMouseDown } = useMouseContent({
        resizer: TABLE_DETAIL_RESIZER,
        isResizing,
        containerRef,
    });

    const {
        fetchData,
        fetchDetailList,
        fetchLotList,
        handleCreateClick,
        handleDeleteClick,
        handleSaveClick,
        handleBarcodeScan,
        initContainerData,
    } = Content_KSK2130_R01({ gridRef, detailGridRef, setMessage });

    return (
        <div className="content-container">
            <Actionbar
                onFetchClick={fetchData}
                onCreateClick={handleCreateClick}
                onDeleteClick={handleDeleteClick}
                onSaveClick={handleSaveClick}
                onInitClick={initContainerData}
            />
            <SearchSection_KSK2130_R01 />
            {isMaterialLotModalVisible && <Modal_KSK2130_R01 />}

            <div
                ref={containerRef}
                className="flex flex-1 min-h-0 flex-col p-[12px] gap-[4px]"
            >
                <div
                    className="w-full min-h-0 flex flex-col"
                    style={{ height: `${splitValue}%` }}
                >
                    <Table_KSK2130_R01
                        gridRef={gridRef}
                        fetchDetailList={fetchDetailList}
                        fetchLotList={fetchLotList}
                    />
                </div>
                <div
                    className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300 shrink-0"
                    onMouseDown={(event) => handleMouseDown("UD", event.nativeEvent)}
                    onDragStart={(event) => event.preventDefault()}
                />
                <div
                    className="w-full min-h-0 flex flex-col gap-[4px]"
                    style={{ height: `${100 - splitValue}%` }}
                >
                    <Info_KSK2130_R01 onScan={handleBarcodeScan} />
                    <div className="flex-1 min-h-0 flex flex-col">
                        <DetailTable_KSK2130_R01 gridRef={detailGridRef} />
                    </div>
                </div>
            </div>
        </div>
    );
};